import useSWR from 'swr';

import { listDashboards } from '@/lib/dashboards-api';

export const DASHBOARD_LIST_KEY = 'dashboards';

export function useDashboardTitles(enabled: boolean): Record<string, string> {
    const { data } = useSWR(enabled ? DASHBOARD_LIST_KEY : null, listDashboards, {
        revalidateOnFocus: false
    });
    return Object.fromEntries((data ?? []).map((item) => [item.id, item.title]));
}
